import SettlementPaymentsModalField from "./SettlementPaymentsModalField";
import SettlementPaymentsSingleSelectDropdown from "./SettlementPaymentsSingleSelectDropdown";
import SettlementPaymentsTextField from "./SettlementPaymentsTextField";

export default function SettlementPaymentsPrimaryFields({ values, paymentTypeOptions, onChange }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <SettlementPaymentsModalField
        label="Payment Type *"
        renderValue={
          <SettlementPaymentsSingleSelectDropdown
            fieldName="paymentType"
            fieldValue={values.paymentType}
            onChange={onChange}
            data={paymentTypeOptions}
          />
        }
      />
      <SettlementPaymentsModalField
        label="Payment Identification"
        renderValue={
          <SettlementPaymentsTextField
            fieldName="paymentId"
            fieldValue={values.paymentId}
            onChange={onChange}
            startAdornment="#"
          />
        }
      />
      <SettlementPaymentsModalField
        label="Payable Amount"
        renderValue={
          <SettlementPaymentsTextField
            fieldName="batchNumber"
            fieldValue={values.batchNumber}
            onChange={onChange}
          />
        }
      />
    </div>
  );
}
